import { render, staticRenderFns } from "./RelationTag.vue?vue&type=template&id=34020983&"
import script from "./RelationTag.vue?vue&type=script&lang=js&"
export * from "./RelationTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports